var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 35.75C7.74333 35.75 0 28.0067 0 18.5C0 8.99333 7.74333 1.25 17.25 1.25C26.7567 1.25 34.5 8.99333 34.5 18.5C34.5 28.0067 26.7567 35.75 17.25 35.75ZM17.25 5.08333C9.85167 5.08333 3.83333 11.1017 3.83333 18.5C3.83333 25.8983 9.85167 31.9167 17.25 31.9167C24.6483 31.9167 30.6667 25.8983 30.6667 18.5C30.6667 11.1017 24.6483 5.08333 17.25 5.08333Z",
    fill: "#393D44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2507 27.2379C16.1773 27.2379 15.334 26.3945 15.334 25.3212V16.8112C15.334 15.7379 16.1773 14.8945 17.2507 14.8945C18.324 14.8945 19.1673 15.7379 19.1673 16.8112V25.3212C19.1673 26.3562 18.324 27.2379 17.2507 27.2379Z",
    fill: "#393D44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2507 13.5951C18.3092 13.5951 19.1673 12.7369 19.1673 11.6784C19.1673 10.6198 18.3092 9.76172 17.2507 9.76172C16.1921 9.76172 15.334 10.6198 15.334 11.6784C15.334 12.7369 16.1921 13.5951 17.2507 13.5951Z",
    fill: "#393D44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.7e3ac3eba0bbbf09c9cf6e5035186ae1.svg";
export { ForwardRef as ReactComponent };